exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.policy-item[data-v-be7dfe90] {\n  color: #576B95;\n  border-radius: 3px;\n}\n", "", {"version":3,"sources":["/root/workspace/ClassKitSite_lZoD/src/components/el-policy-item.vue"],"names":[],"mappings":";AAuCA;EACE,eAAe;EACf,mBAAmB;CACpB","file":"el-policy-item.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.policy-item {\n  color: #576B95;\n  border-radius: 3px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-be7dfe90","scoped":true,"hasInlineConfig":false}!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/el-policy-item.vue
// module id = /Co3
// module chunks = 165